import React, { Component } from "react";
import styled from "styled-components";
import * as Widget from "./Widget2";
import JoinUsDialog from "./JoinUsDialog";

class CooperationSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false
    };
  }

  render() {
    let { openDialog } = this.state;

    return (
      <Wrapper>
        <Widget.SectionTitle haveMarginBottom={true}>
          商業合作
        </Widget.SectionTitle>
        <Widget.SectionLine />
        <Widget.SectionContainer>
          <div className="text">
            {
              "好咖嚴選專注在為台灣精品咖啡市場打造一個簡單、生活化且讓人喜愛的線上入口。\n不論您是咖啡廳、媒體還是純粹的咖啡愛好者，\n有任何有趣的合作或想法都歡迎跟我們聯絡喔！"
            }
          </div>
          <Widget.BrownButton
            onClick={() => this.setState({ openDialog: true })}
          >
            加入我們
          </Widget.BrownButton>
        </Widget.SectionContainer>
        <Widget.SectionLine />

        {openDialog && (
          <JoinUsDialog
            open={openDialog}
            onClose={() => this.setState({ openDialog: false })}
          />
        )}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
`;

export default CooperationSection;
